import { useState } from "react";

export const useFocusState = () => {
	const [isFocus, setFocusState] = useState<boolean>(false);

	const focusProps = {
		onFocus: () => {
			setFocusState(true);
		},
		onBlur: () => {
			setFocusState(false);
		},
	};

	return [isFocus, focusProps] as [boolean, typeof focusProps];
};
